import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'modal[cssClass],modal[wide],modal[skinny],modal[skinnier],modal[disable-tabs-in-modal-css]',
  standalone: false,
})
export class WlModalCssClassDirective {
  public static readonly wideClass: string = 'wl-modal-dialog-wide';
  public static readonly skinnyClass: string = 'wl-modal-dialog-skinny';
  public static readonly skinnierClass: string = 'wl-modal-dialog-skinnier';
  public static readonly disableTabsModalCssClass: string = 'wl-disable-tabs-in-modal-css';

  /**
   * add a custom css class
   */
  @Input() public get cssClass(): string {
    return this._cssClass;
  }
  public set cssClass(value: string) {
    this._cssClass = value;
    this.changeCssClass();
  }

  /**
   * add this attribute to make a wide modal, but not as wide as the screen
   */
  @Input() public get wide(): boolean {
    return this._wide;
  }
  public set wide(value: boolean) {
    this._wide = value;

    this.changeCssClass();
  }

  /**
   * add this attribute to make a skinny modal
   */
  @Input() public get skinny(): boolean {
    return this._skinny;
  }
  public set skinny(value: boolean) {
    this._skinny = value;

    this.changeCssClass();
  }

  /**
   * add this to DISABLE making the fancy non-scrolling tabs when inside a modal (you usually want to leave this enabled)
   */
  @Input('disable-tabs-in-modal-css') public get disableTabsInMocalCss(): boolean {
    return this._disableTabsInMocalCss;
  }
  public set disableTabsInMocalCss(value: boolean) {
    this._disableTabsInMocalCss = value;

    this.changeCssClass();
  }

  /**
   * add this attribute to make a skinnier modal
   */
  @Input() public get skinnier(): boolean {
    return this._skinnier;
  }
  public set skinnier(value: boolean) {
    this._skinnier = value;

    this.changeCssClass();
  }

  public _cssClass: string = '';
  public _wide: boolean = false;
  public _skinny: boolean = false;
  public _skinnier: boolean = false;
  public _disableTabsInMocalCss: boolean = false;

  /**
   * injection
   * @param _modal
   * @param _element
   */
  constructor(public _element: ElementRef) {}

  /**
   * add the css class to the modal's div
   */
  public changeCssClass(): void {
    if (!this._element || !this._element.nativeElement) return;

    let modalControlElement: HTMLDivElement = <HTMLDivElement>this._element.nativeElement;
    let modalContentDiv: Element = modalControlElement.querySelector('.modal-dialog');

    // apply classes
    if (modalContentDiv) {
      if (modalContentDiv.className.search(new RegExp('\b' + this._cssClass + '\b')) < 0) modalContentDiv.className += ' ' + this._cssClass;

      if (this._wide && modalContentDiv.className.search(new RegExp('\b' + WlModalCssClassDirective.wideClass + '\b')) < 0)
        modalContentDiv.className += ' ' + WlModalCssClassDirective.wideClass;

      if (this._skinny && modalContentDiv.className.search(new RegExp('\b' + WlModalCssClassDirective.skinnyClass + '\b')) < 0)
        modalContentDiv.className += ' ' + WlModalCssClassDirective.skinnyClass;

      if (this._skinnier && modalContentDiv.className.search(new RegExp('\b' + WlModalCssClassDirective.skinnierClass + '\b')) < 0)
        modalContentDiv.className += ' ' + WlModalCssClassDirective.skinnierClass;

      if (
        this._disableTabsInMocalCss &&
        modalContentDiv.className.search(new RegExp('\b' + WlModalCssClassDirective.disableTabsModalCssClass + '\b')) < 0
      )
        modalContentDiv.className += ' ' + WlModalCssClassDirective.disableTabsModalCssClass;
    }
  }
}
